import type {Component} from '@kpsys/angularjs-register';
import type {ReportTemplate} from 'typings/portaro.be.types';
import type ReportServerDataService from '../report-server.data-service';

export class KpReportTemplateItemComponentController implements KpReportTemplateItemComponentBindings {
    public reportTemplate: ReportTemplate;

    /*@ngInject*/
    constructor(private reportServerDataService: ReportServerDataService) {
    }

    public async getTemplateParameters(report) {
        await this.reportServerDataService.getTemplateParameters(report);
    }
}

/**
 * @ngdoc component
 * @name kpReportTemplateItemComponent
 * @module use-cases.report-server
 *
 * @param {ReportTemplate=} reportTemplate
 *
 * @description
 *
 * Component which holds information about ReportTemplate, belongs to kpReportServerFolderComponent
 *
 */
export default class KpReportTemplateItemComponent implements Component<KpReportTemplateItemComponentBindings> {
    public static readonly componentName = 'kpReportTemplateItem';

    public templateUrl = require('./kp-report-template-item.tpl.ftl');

    public bindings = {
        reportTemplate: '<',
    } as const;

    public controller = KpReportTemplateItemComponentController;
}

interface KpReportTemplateItemComponentBindings {
    reportTemplate: ReportTemplate;
}
